import { apiRequest } from '../http';
import { IOperationTimesRepository } from './IOperationTimesRepository';
import { OperationTimeRecord, OperationTimeFilters, PagedResult, CreateActivityInput, UpdateActivityInput } from './types';

/**
 * Implementacion "remote": consume la API en Cloudflare Workers
 * (rutas definidas en apps/api/src/modules/operation-times/routes.ts).
 */
export class RemoteOperationTimesRepository implements IOperationTimesRepository {
  constructor(private getToken: () => Promise<string | null>) {}

  async create(input: CreateActivityInput): Promise<OperationTimeRecord> {
    const token = await this.getToken();
    return apiRequest('/api/operation-times', { method: 'POST', body: input, token });
  }

  async list(filters: OperationTimeFilters): Promise<PagedResult<OperationTimeRecord>> {
    const token = await this.getToken();
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, String(value));
      }
    });
    return apiRequest(`/api/operation-times?${params.toString()}`, { token });
  }

  async getById(id: string): Promise<OperationTimeRecord | null> {
    const token = await this.getToken();
    return apiRequest(`/api/operation-times/${id}`, { token });
  }

  async update(id: string, patch: UpdateActivityInput): Promise<OperationTimeRecord> {
    const token = await this.getToken();
    return apiRequest(`/api/operation-times/${id}`, { method: 'PATCH', body: patch, token });
  }

  async remove(id: string, reason: string): Promise<void> {
    const token = await this.getToken();
    await apiRequest(`/api/operation-times/${id}`, { method: 'DELETE', body: { reason }, token });
  }
}
